import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KeyCodeWithModifiersClass;
function KeyCodeWithModifiers() {
  if (KeyCodeWithModifiersClass === VOID) {
    class $ {
      constructor(code, alt, ctrl, shift, meta) {
        alt = alt === VOID ? false : alt;
        ctrl = ctrl === VOID ? false : ctrl;
        shift = shift === VOID ? false : shift;
        meta = meta === VOID ? false : meta;
        this.code_1 = code;
        this.alt_1 = alt;
        this.ctrl_1 = ctrl;
        this.shift_1 = shift;
        this.meta_1 = meta;
      }
      toString() {
        return 'KeyCodeWithModifiers(code=' + this.code_1 + ', alt=' + this.alt_1 + ', ctrl=' + this.ctrl_1 + ', shift=' + this.shift_1 + ', meta=' + this.meta_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.code_1);
        result = imul(result, 31) + getBooleanHashCode(this.alt_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.ctrl_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.shift_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.meta_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KeyCodeWithModifiers()))
          return false;
        if (!(this.code_1 === other.code_1))
          return false;
        if (!(this.alt_1 === other.alt_1))
          return false;
        if (!(this.ctrl_1 === other.ctrl_1))
          return false;
        if (!(this.shift_1 === other.shift_1))
          return false;
        if (!(this.meta_1 === other.meta_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KeyCodeWithModifiers');
    KeyCodeWithModifiersClass = $;
  }
  return KeyCodeWithModifiersClass;
}
//region block: exports
export {
  KeyCodeWithModifiers as KeyCodeWithModifiersyrb06kjwhumy,
};
//endregion

//# sourceMappingURL=KeyCode.mjs.map
